var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenReturnArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.483 2.672a.77.77 0 00-.97 0L1.705 6.024c-.437.373-.123 1.024.478 1.024H4.64v7.246c0 .663.614 1.206 1.365 1.206s1.366-.543 1.366-1.206V7.048h2.444c.615 0 .915-.65.478-1.024l-3.81-3.352zM11.352 15.621l3.39 3.097a1.165 1.165 0 001.519 0l3.395-3.101.083-.082c.615-.667.093-1.733-.845-1.733h-1.685v-6.19c0-.897-.78-1.612-1.714-1.612l-.146.006c-.868.07-1.568.756-1.568 1.607v6.189h-1.672c-.988 0-1.504 1.155-.757 1.82zm.757-.82h2.672V7.614c0-.326.314-.613.714-.613.4 0 .714.287.714.613v7.189h2.685c.097 0 .119.048.093.072l-3.392 3.098c-.046.04-.142.04-.196-.008l-3.378-3.086c-.036-.032-.016-.076.088-.076z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenReturnArrows);
export default __webpack_public_path__ + "static/media/open-return-arrows.19821665.svg";
export { ForwardRef as ReactComponent };